import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import * as CKEditor from '@ckeditor/ckeditor5-build-classic';
import { AnswersService } from '../services/answers.service';
import { AuthService } from '../services/auth.service';
import { QuestionsService } from '../services/questions.service';

@Component({
  selector: 'app-getanswers',
  templateUrl: './getanswers.component.html',
  styleUrls: ['./getanswers.component.css']
})
export class GetanswersComponent implements OnInit {
  public Editor = CKEditor;
  islogged: Boolean;
  answers = [];
  question: any;
  comments = [];
  user: any;
  newanswer: string;
  commentopen: boolean[] = [false];
  answeruser:any[]=[];
  commentuser: any[]=[];
  answerpictures: string[]=[];
  mostpopular = [];
  constructor(private route: ActivatedRoute, 
    private answerService: AnswersService, private questionService: QuestionsService,
    private authService: AuthService,@Inject('imgbaseURL') private imgbaseURL, private router: Router) { }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    //console.log(id);
    this.answerService.getanswersbyQ_ID(id).subscribe(res=>{
      this.answers = [];
      res.results.forEach(result=>{
        this.authService.getUserdetailByUsername(result.username).subscribe(nextres=>{
          this.answers.push({...result, 
          profile_picture: nextres.profile_picture});
          //console.log(res);
        });
      });
     // console.log("Answers",this.answers);
      //this.getanswerprofile();
    });
    this.questionService.getquestionbyID(id).subscribe(res=>{
      this.question = res;
     // console.log("Question");
      this.getprofilepicture(this.question.username);
    });
    this.questionService.mostpopularquestion().subscribe(res=>{
      this.mostpopular = res.results.slice(0,5);
     // console.log("mostpopular",this.mostpopular.slice(0,5));
    });

    this.islogged = this.authService.isLoggedIn();
  }

  getprofilepicture(user){
    this.authService.getUserdetailByUsername(user).subscribe(res=>{
      this.user = res;
      //console.log(res);
    });
  }

  /*getanswerprofile(){
    this.answeruser=[];
    let i = 0;
    while(i<this.answers.count){
      console.log(this.answers.results[i].username);
      this.authService.getUserdetailByUsername(this.answers.results[i].username).subscribe(res=>{
        this.answeruser.push({username: res.username,profile_picture: res.profile_picture});
        //console.log(res);
      });
      i++;
    }
    console.log(this.answeruser);
  }

  getcommentprofile(user){
    let i = 0;
    let j = 0;
      while(j<this.comments[i].results.length){
        this.getcommentprofile(this.comments[i].results[j].username);
        j++;
    }
  }*/

  sendAnswer(val){
    if(this.islogged){
      console.log(val.value);
      const id = this.route.snapshot.paramMap.get('id');
      this.newanswer = val.value;
      this.answerService.postUseranswer(this.newanswer, id).subscribe(
        res=>{
          if(res){
            console.log("Answer Posted:" + this.newanswer);
            this.ngOnInit();
          }
        },error=>{
          console.log(error);
        }
      );
    }
    else{
      this.router.navigateByUrl("/login");
    }
  }

  upvoteanswer(id){
    this.answerService.answerUpvote(id).subscribe(
      res=>{
        if(res){
          console.log("Upvote:" + id);
          this.ngOnInit();
        }
      },error=>{
        console.log(error);
      }
    );;
  }
  upvotequestion(id){
    this.questionService.questionUpvote(id).subscribe(
      res=>{
        if(res){
          console.log("Upvote:" + id);
          this.ngOnInit();
        }
      },error=>{
        console.log(error);
      }
    );;
  }
  upvotecomment(i,ans_id, comment_id){
    this.answerService.commentUpvote(comment_id).subscribe(
      res=>{
        if(res){
          console.log("Upvote:" + comment_id);
          this.commentopen[i] = !this.commentopen[i];
          this.ngOnInit();
        }
      },error=>{
        console.log(error);
      }
    );;
  }

  commentOpen(i, ans_id){
    this.commentopen[i] = !this.commentopen[i];
    this.getComments(i, ans_id);
  }

  getComments(i, ans_id){
    this.comments[i] = [];
    this.answerService.getcommentsbyAns_ID(ans_id).subscribe(res=>{
      //console.log(res);
      let j = 0;
      res.results.forEach(result=>{
        this.authService.getUserdetailByUsername(result.username).subscribe(nextres=>{
          this.comments[i].push({...result, 
          profile_picture: nextres.profile_picture,index: i});
        });
      });
    //console.log(this.comments[i]);
    //console.log("Comments");
  });
  }

  sendComment(i, val,ans_id){
    console.log(val);
    this.answerService.postUsercomment(val, ans_id).subscribe(
      res=>{
        if(res){
          console.log("Comment Posted:" + val);
          this.getComments(i, ans_id);
          this.ngOnInit();
        }
      },error=>{
        console.log(error);
      }
    );
  }

}
